/* eslint-disable max-lines */
export const Colors = {
  baseBrand50: '#011e2f',
  baseBrand100: '#012F49',
  baseBrand200: '#06456C',
  baseBrand300: '#044B77',
  baseBrand400: '#06649F',
  baseBrand500: '#0789D9',
  baseBrand600: '#3597d4',
  baseBrand700: '#53A8DD',
  baseBrand800: '#7ABDE7',
  baseBrand900: '#8DC8ED',
  baseSteel50: '#36373a',
  baseSteel100: '#313235',
  baseSteel200: '#7E8086',
  baseSteel300: '#A2A4A8',
  baseSteel400: '#adafb4',
  baseSteel500: '#D7D8DB',
  baseSteel600: '#c9cbcf',
  baseSteel700: '#D7D8DB',
  baseSteel800: '#f7f8f9',
  baseSteel900: '#fff',
  baseGray50: '#070708',
  baseGray100: '#0E0E0F',
  baseGray200: '#1d1d20',
  baseGray300: '#1B1C1E',
  baseGray400: '#2E2F33',
  baseGray500: '#36353b',
  baseGray600: '#3e3d42',
  baseGray700: '#5A595F',
  baseGray800: '#6F6E74',
  baseGray900: '#838288',
  baseBlue50: '#011e2f',
  baseBlue100: '#012F49',
  baseBlue200: '#06456C',
  baseBlue300: '#044B77',
  baseBlue400: '#06649F',
  baseBlue500: '#0789D9',
  baseBlue600: '#3597d4',
  baseBlue700: '#53A8DD',
  baseBlue800: '#7ABDE7',
  baseBlue900: '#8DC8ED',
  baseGreen50: '#001009',
  baseGreen100: '#00331E',
  baseGreen200: '#003720',
  baseGreen300: '#005330',
  baseGreen400: '#006E40',
  baseGreen500: '#009657',
  baseGreen600: '#1AA168',
  baseGreen700: '#33B981',
  baseGreen800: '#4DD099',
  baseGreen900: '#5ADCA5',
  baseRed50: '#120100',
  baseRed100: '#400500',
  baseRed200: '#571C17',
  baseRed300: '#882D25',
  baseRed400: '#AE3A30',
  baseRed500: '#DA4538',
  baseRed600: '#da5145',
  baseRed700: '#E59189',
  baseRed800: '#EEB5B1',
  baseRed900: '#F2C8C4',
  baseYellow50: '#140b00',
  baseYellow100: '#422600',
  baseYellow200: '#553A15',
  baseYellow300: '#70460D',
  baseYellow400: '#8E5910',
  baseYellow500: '#B57500',
  baseYellow600: '#D49B4C',
  baseYellow700: '#f6c785',
  baseYellow800: '#ffdfb1',
  baseYellow900: '#ffedd6',
  interactivePrimaryDefault: '#0789D9',
  interactivePrimaryActive: '#0789D9',
  interactivePrimaryHover: '#3597d4',
  interactivePrimaryPressed: '#53A8DD',
  interactiveSuccessDefault: '#009657',
  interactiveSuccessHover: '#1AA168',
  interactiveSuccessPressed: '#33B981',
  interactiveSuccessActive: '#33B981',
  interactiveSuccessDisabled: '#005330',
  interactiveWarningDefault: '#B57500',
  interactiveWarningHover: '#D49B4C',
  interactiveWarningPressed: '#f6c785',
  interactiveCriticalDefault: '#DA4538',
  interactiveCriticalHover: '#da5145',
  interactiveCriticalPressed: '#E59189',
  interactiveInfoDefault: '#0789D9',
  interactiveInfoHover: '#3597d4',
  interactiveInfoPressed: '#53A8DD',
  interactiveNeutralDefault: '#2E2F33',
  interactiveNeutralHover: '#36353b',
  interactiveNeutralPressed: '#3e3d42',
  interactiveNeutralDisabled: '#5A595F',
  backgroundViewDarker: '#36373a',
  backgroundViewHoverBackground: '#011e2f',
  backgroundViewLighter: '#0E0E0F',
  backgroundViewLight: '#1d1d20',
  backgroundViewApp: '#1B1C1E',
  backgroundViewHover: '#2E2F33',
  backgroundViewNavi: '#36353b',
  backgroundSystemInfoLight: '#012032',
  backgroundSystemInfoDefault: '#012F49',
  backgroundSystemCritcal: '#400500',
  backgroundSystemWarning: '#422600',
  backgroundSystemSuccess: '#00331E',
  backgroundPrivateDefault: '#2d2c23',
  backgroundPrivateLight: '#25241d',
  backgroundPrivateDark: '#343228',
  backgroundGradientBrand: 'linear-gradient(270deg, #077DC7 0%, #143DA0 100%)',
  backgroundGradientNeutral: 'linear-gradient(180deg, #222326 0%, #1d1d20 100%)',
  backgroundGradientLead: 'linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)',
  backgroundGradientScale: 'linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)',
  backgroundGradientLaunch: 'linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)',
  backgroundGradientPurple: 'linear-gradient(-90deg, #C177D5 30%, #653EAC 70%)',
  backgroundGradientOrange: 'linear-gradient(90deg, #C45A03 27.46%, #EEAF0C 100%)',
  backgroundGradientRed: 'linear-gradient(90deg, #F9062B 27.46%, #FFDBD4 100%)',
  backgroundGradientLightBlue: 'linear-gradient(45deg, #0789D9 0%, #62C2F9 100%)',
  backgroundGradientVideo:
    'linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)',
  backgroundGradientVideoOverlay:
    'linear-gradient(45deg, rgba(#174298, 0.7) 0%, rgba(#7148bd, 0.7) 52%, rgba(#af7ee6, 0.7) 100%)',
  backgroundGradientFindTimeGray:
    'repeating-linear-gradient(135deg, #303236, #303236 6px, #484A51 6px, #484A51 12px)',
  backgroundGradientFindTimeBlue:
    'repeating-linear-gradient(135deg, #012F49, #012F49 6px, #06456C 6px, #06456C 12px)',
  backgroundGradientFindTimeViolet:
    'repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)',
  backgroundGradientMask:
    'linear-gradient(-60deg, #e8198a 30%, #e8198a5, #e8198a 70%) right/300% 100%',
  backgroundGradientRainbow:
    'linear-gradient(90deg, rgb(90, 55, 154) 0%, rgb(184, 99, 207) 7%, rgb(20, 121, 179) 14%, rgb(73, 184, 248) 21%, rgb(85, 199, 82) 27%, rgb(39, 150, 118) 33.33%, rgb(104, 205, 101) 36%, rgb(98, 194, 249) 42%, rgb(22, 136, 202) 47%, rgb(193, 119, 213) 53%, rgb(101, 62, 172) 60%, rgb(22, 136, 202) 66.66%, rgb(98, 194, 249) 100%)',
  backgroundGradientGrayToTransparent:
    'linear-gradient(to bottom, rgba(29, 30, 32, 1) 0%, rgba(29, 30, 32, 0) 100%)',
  borderNeutralDefault: '#3e3d42',
  borderNeutralDark: '#5A595F',
  borderNeutralDisabled: '#36353b',
  borderSystemInfo: '#0789D9',
  borderSystemSuccess: '#009657',
  borderSystemCritical: '#DA4538',
  borderSystemWarning: '#B57500',
  borderMainPrimary: '#0789D9',
  textSystemInfo: '#3597d4',
  textSystemSuccess: '#1AA168',
  textSystemWarning: '#D49B4C',
  textSystemCritical: '#da5145',
  textMainDefault: '#fff',
  textMainSubdued: '#D7D8DB',
  textMainDisabled: '#A2A4A8',
  iconSystemInfo: '#0789D9',
  iconSystemSuccess: '#009657',
  iconSystemWarning: '#B57500',
  iconSystemCritical: '#DA4538',
  iconMainBrand: '#0789D9',
  iconMainDefault: '#fff',
  iconMainSubdued: '#D7D8DB',
  iconMainDisabled: '#A2A4A8',
  miscSpecialPersonal: '#B26D00',
  miscSpecialViolet: '#6473C6',
  miscSpecialOrange: '#EA6A00',
  miscSpecialOrangeLight: '#1D1A18',
  miscSpecialYellow: '#D19804',
  miscSpecialIndigo: '#0A2463',
  miscSpecialDarkYellow: '#444336',
  miscSpecialDarkBlue: '#0C285E',
  miscSpecialLime: '#709F00',
  miscSocialFacebook: '#41599c',
  miscSocialTwitter: '#3dacf0',
  miscSocialGooglePlus: '#d34836',
  miscSocialLinkedin: '#2b80b5',
  pricingScaleDefault: '#219475',
  pricingScaleHover: '#239E7D',
  pricingScaleSubdued: '#0D3A31',
  pricingLeadDefault: '#835EC7',
  pricingLeadHover: '#8D6BCC',
  pricingLeadSubdued: '#23153d',
  white: '#ffffff',
  black: '#121317',
  colorBgDefault: '#222326',
  colorBgHover: '#2E2F33',
  colorBgActive: '#012F49',
  colorBgDisabled: '#3e3d42',
  colorBgSelected: '#012F49',
  colorBgPrimaryDefault: '#0789D9',
  colorBgPrimaryHover: '#3597d4',
  colorBgPrimaryPressed: '#53A8DD',
  colorBgPrimarySelected: '#0789D9',
  colorBgPrimarySubduedHover: '#011e2f',
  colorBgPrimarySubduedSelected: '#011e2f',
  colorBgPrimarySubduedActive: '#011e2f',
  colorBgPrimaryStrongDefault: '#3597d4',
  colorBgNeutralDefault: '#1B1C1E',
  colorBgNeutralHover: '#36353b',
  colorBgNeutralPressed: '#3e3d42',
  colorBgNeutralDisabled: '#5A595F',
  colorBgNeutralSelected: '#2E2F33',
  colorBgNeutralLowDefault: '#1d1d20',
  colorBgNeutralLowHover: '#36373a',
  colorBgNeutralLowDisabled: '#1B1C1E',
  colorBgNeutralStrongDefault: '#3e3d42',
  colorBgNeutralStrongHover: '#5A595F',
  colorBgSuccessDefault: '#009657',
  colorBgSuccessHover: '#1AA168',
  colorBgSuccessPressed: '#33B981',
  colorBgSuccessDisabled: '#005330',
  colorBgSuccessLowDefault: '#00331E',
  colorBgSuccessLowHover: '#00331E',
  colorBgSuccessLowPressed: '#00331E',
  colorBgCriticalDefault: '#DA4538',
  colorBgCriticalHover: '#da5145',
  colorBgCriticalPressed: '#E59189',
  colorBgCriticalLowDefault: '#400500',
  colorBgCriticalLowHover: '#400500',
  colorBgCriticalLowPressed: '#400500',
  colorBgCriticalStrongDefault: '#da5145',
  colorBgCriticalStrongActive: '#E59189',
  colorBgWarningDefault: '#B57500',
  colorBgWarningHover: '#D49B4C',
  colorBgWarningPressed: '#f6c785',
  colorBgWarningLowDefault: '#422600',
  colorBgWarningLowHover: '#422600',
  colorBgWarningLowPressed: '#422600',
  colorBgScaleDefault: '#219475',
  colorBgScaleHover: '#239E7D',
  colorBgScaleSubduedDefault: '#0D3A31',
  colorBgLeadDefault: '#835EC7',
  colorBgLeadHover: '#8D6BCC',
  colorBgLeadSubduedDefault: '#23153d',
  colorBgPrivateDefault: '#2d2c23',
  colorBgPrivateHover: '#343228',
  colorBgPrivateStrongDefault: '#343228',
  colorBgPrivateLowDefault: '#25241d',
  colorBgGradientSubdued: 'linear-gradient(180deg, #222326 0%, #1d1d20 100%)',
  colorBgSecondaryDefault: '#D7D8DB',
  colorBgSecondaryDisabled: '#36373a',
  colorBgSecondaryStrongDefault: '#fff',
  colorBgSecondaryStrongHover: '#D7D8DB',
  colorBgSecondaryStrongPressed: '#c9cbcf',
  colorBgSecondaryStrongActive: '#f7f8f9',
  colorBgSecondarySubduedDefault: '#313235',
  colorBgSecondaryLowDefault: '#adafb4',
  colorBgSecondaryLowDisabled: '#A2A4A8',
  colorBgInfoDefault: '#0789D9',
  colorBgInfoStrongDefault: '#3597d4',
  colorBgInfoLowDefault: '#012F49',
  colorBgInfoLowHover: '#012F49',
  colorBgInfoLowPressed: '#012F49',
  colorBgOverdueDefault: '#EA6A00',
  colorBgOverdueLowDefault: '#1D1A18',
  colorBgNoconsentDefault: '#1D1A18',
  colorBgNodataDefault: '#1D1A18',
  colorBgTeamDefault: '#6473C6',
  colorBgPersonalDefault: '#B26D00',
  colorBgOverlayDefault: 'rgba(54,53,59,0.7)',
  colorBgOnoverlayHover: 'rgba(255,255,255,0.1)',
  colorBgOnoverlayPressed: 'rgba(255,255,255,0.2)',
  colorBgGhostHover: 'rgba(255,255,255,0.1)',
  colorBgGhostPressed: 'rgba(255,255,255,0.2)',
  colorBgTintDefault: 'rgba(255,255,255,0.3)',
  colorBgLoadingDefault: 'rgba(255,255,255,0.15)',
  colorBgOfferDefault: '#709F00',
  colorBgScreeningDefault: '#06456C',
  colorBgInterviewDefault: '#0789D9',
  colorBgEvaluationDefault: '#53A8DD',
  colorBgHiredDefault: '#009657',
  colorBgTranslateDefault: '#B57500',
  colorBgChartDefault: 'rgba(25, 153, 227, 0.1)',
  colorBgVersatileSecondaryStrongDefault: '#121317',
  colorBgVersatileSecondaryStrongHover: '#363944',
  colorBgVersatileSecondaryStrongPressed: '#484c5b',
  colorBgVersatileSecondaryStrongActive: '#24262e',
  colorBgVersatileSecondaryDefault: '#5a5f72',
  colorBgVersatileSecondaryHover: '#484C5B',
  colorTextDefault: '#D7D8DB',
  colorTextHover: '#fff',
  colorTextPressed: '#fff',
  colorTextDisabled: '#A2A4A8',
  colorTextStrongDefault: '#fff',
  colorTextStrongHover: '#fff',
  colorTextStrongSelected: '#fff',
  colorTextLowDefault: '#adafb4',
  colorTextOnprimaryDefault: '#ffffff',
  colorTextOnprimaryHover: '#ffffff',
  colorTextOnprimaryPressed: '#ffffff',
  colorTextOnprimaryDisabled: '#ffffff',
  colorTextOnprimarySelected: '#ffffff',
  colorTextOnneutralDisabled: '#9F9EA1',
  colorTextOnsuccessDefault: '#ffffff',
  colorTextOnsuccessHover: '#ffffff',
  colorTextOnsuccessPressed: '#ffffff',
  colorTextOncriticalDefault: '#ffffff',
  colorTextOncriticalHover: '#ffffff',
  colorTextOncriticalPressed: '#ffffff',
  colorTextOnwarningDefault: '#ffffff',
  colorTextOnwarningHover: '#ffffff',
  colorTextOnwarningPressed: '#ffffff',
  colorTextSuccessDefault: '#009657',
  colorTextSuccessHover: '#009657',
  colorTextSuccessPressed: '#1AA168',
  colorTextSuccessStrongDefault: '#1AA168',
  colorTextCriticalDefault: '#DA4538',
  colorTextCriticalHover: '#DA4538',
  colorTextCriticalPressed: '#da5145',
  colorTextCriticalStrongDefault: '#da5145',
  colorTextInfoDefault: '#0789D9',
  colorTextInfoHover: '#0789D9',
  colorTextInfoPressed: '#3597d4',
  colorTextInfoStrongDefault: '#3597d4',
  colorTextWarningDefault: '#B57500',
  colorTextWarningHover: '#B57500',
  colorTextWarningPressed: '#D49B4C',
  colorTextWarningStrongDefault: '#D49B4C',
  colorTextOnscaleDefault: '#ffffff',
  colorTextOnscaleHover: '#ffffff',
  colorTextOnleadDefault: '#ffffff',
  colorTextOnleadHover: '#ffffff',
  colorTextScaleDefault: '#219475',
  colorTextScaleHover: '#239E7D',
  colorTextOngradientDefault: '#ffffff',
  colorTextLeadDefault: '#835EC7',
  colorTextOnsecondaryDefault: '#ffffff',
  colorTextOnsecondaryStrongDefault: '#ffffff',
  colorTextOnsecondaryStrongHover: '#ffffff',
  colorTextOnsecondaryStrongPressed: '#ffffff',
  colorTextOninfoStrongDefault: '#ffffff',
  colorTextOverdueDefault: '#EA6A00',
  colorTextOnoverdueDefault: '#ffffff',
  colorTextNoconsentDefault: '#EA6A00',
  colorTextNodataDefault: '#EA6A00',
  colorTextOnoverlayDefault: '#ffffff',
  colorTextOnoverlayHover: '#ffffff',
  colorTextOnoverlayPressed: '#ffffff',
  colorTextOnoverlayDisabled: '#adafb4',
  colorTextOnoverlayLowDefault: '#36353b',
  colorTextOnghostDefault: '#ffffff',
  colorTextOnghostHover: '#ffffff',
  colorTextOnghostPressed: '#ffffff',
  colorTextOnghostDisabled: '#adafb4',
  colorTextPrimaryDefault: '#0789D9',
  colorTextPrimaryActive: '#0789D9',
  colorTextPrimaryHover: '#3597d4',
  colorTextPrimaryStrongDefault: '#3597d4',
  colorTextOnteamDefault: '#ffffff',
  colorTextOncomponentDefault: '#ffffff',
  colorIconDefault: '#D7D8DB',
  colorIconHover: '#fff',
  colorIconPressed: '#fff',
  colorIconDisabled: '#A2A4A8',
  colorIconStrongDefault: '#fff',
  colorIconOnprimaryDefault: '#ffffff',
  colorIconOnprimaryHover: '#ffffff',
  colorIconOnprimaryPressed: '#ffffff',
  colorIconOnprimaryDisabled: '#ffffff',
  colorIconOnneutralDisabled: '#9F9EA1',
  colorIconOnsuccessDefault: '#ffffff',
  colorIconOnsuccessHover: '#ffffff',
  colorIconOnsuccessPressed: '#ffffff',
  colorIconOnsuccessDisabled: '#ffffff',
  colorIconOncriticalDefault: '#ffffff',
  colorIconOncriticalHover: '#ffffff',
  colorIconOncriticalPressed: '#ffffff',
  colorIconOnwarningDefault: '#ffffff',
  colorIconOnwarningHover: '#ffffff',
  colorIconOnwarningPressed: '#ffffff',
  colorIconSuccessDefault: '#009657',
  colorIconSuccessHover: '#009657',
  colorIconSuccessPressed: '#1AA168',
  colorIconSuccessActive: '#33B981',
  colorIconSuccessStrongDefault: '#1AA168',
  colorIconCriticalDefault: '#DA4538',
  colorIconCriticalHover: '#DA4538',
  colorIconCriticalPressed: '#da5145',
  colorIconCriticalStrongDefault: '#da5145',
  colorIconInfoDefault: '#0789D9',
  colorIconInfoHover: '#0789D9',
  colorIconInfoPressed: '#3597d4',
  colorIconInfoStrongDefault: '#3597d4',
  colorIconWarningDefault: '#B57500',
  colorIconWarningHover: '#B57500',
  colorIconWarningPressed: '#D49B4C',
  colorIconWarningStrongDefault: '#D49B4C',
  colorIconScaleDefault: '#219475',
  colorIconScaleHover: '#239E7D',
  colorIconOngradientDefault: '#ffffff',
  colorIconOnscaleDefault: '#ffffff',
  colorIconOnscaleHover: '#ffffff',
  colorIconLeadDefault: '#835EC7',
  colorIconOnleadDefault: '#ffffff',
  colorIconOnleadHover: '#ffffff',
  colorIconOnsecondaryDefault: '#ffffff',
  colorIconOnsecondaryStrongDefault: '#ffffff',
  colorIconOnsecondaryStrongHover: '#ffffff',
  colorIconOninfoStrongDefault: '#ffffff',
  colorIconOverdueDefault: '#EA6A00',
  colorIconOnoverdueDefault: '#ffffff',
  colorIconNoconsentDefault: '#EA6A00',
  colorIconNodataDefault: '#EA6A00',
  colorIconOnoverlayDefault: '#ffffff',
  colorIconOnoverlayHover: '#ffffff',
  colorIconOnoverlayPressed: '#ffffff',
  colorIconOnoverlayDisabled: '#adafb4',
  colorIconOnghostDefault: '#ffffff',
  colorIconOnghostHover: '#ffffff',
  colorIconOnghostPressed: '#ffffff',
  colorIconOnghostDisabled: '#adafb4',
  colorIconPrimaryDefault: '#0789D9',
  colorIconPrimaryHover: '#3597d4',
  colorIconPrimaryPressed: '#0789D9',
  colorIconPrimaryStrongDefault: '#3597d4',
  colorIconLowDefault: '#adafb4',
  colorIconLowDisabled: '#5A595F',
  colorIconSubduedDefault: '#313235',
  colorIconOncomponentDefault: '#ffffff',
  colorBorderDefault: '#3e3d42',
  colorBorderHover: '#3e3d42',
  colorBorderPressed: '#3e3d42',
  colorBorderDisabled: '#36353b',
  colorBorderSelected: '#3e3d42',
  colorBorderSuccessDefault: '#009657',
  colorBorderSuccessHover: '#009657',
  colorBorderSuccessPressed: '#1AA168',
  colorBorderSuccessSubduedDefault: '#003720',
  colorBorderSuccessLowDefault: '#006E40',
  colorBorderCriticalDefault: '#DA4538',
  colorBorderCriticalHover: '#DA4538',
  colorBorderCriticalPressed: '#da5145',
  colorBorderCriticalLowDefault: '#882D25',
  colorBorderCriticalSubduedDefault: '#571C17',
  colorBorderInfoDefault: '#0789D9',
  colorBorderInfoHover: '#0789D9',
  colorBorderInfoPressed: '#3597d4',
  colorBorderInfoSubduedDefault: '#06456C',
  colorBorderWarningDefault: '#B57500',
  colorBorderWarningHover: '#B57500',
  colorBorderWarningPressed: '#D49B4C',
  colorBorderWarningSubduedDefault: '#553A15',
  colorBorderNeutralHover: '#5A595F',
  colorBorderNeutralDisabled: '#1B1C1E',
  colorBorderOncomponentDefault: '#222326',
  colorBorderSecondaryDefault: '#D7D8DB',
  colorBorderSecondaryHover: '#fff',
  colorBorderSecondaryLowDefault: '#adafb4',
  colorBorderSecondaryLowDisabled: '#7E8086',
  colorBorderSecondaryStrongDefault: '#D7D8DB',
  colorBorderPrimaryDefault: '#0789D9',
  colorBorderPrimaryHover: '#3597d4',
  colorBorderPrimaryStrongDefault: '#3597d4',
  colorBorderPrimarySubduedDefault: '#06456C',
  colorBorderPrimaryLowDefault: '#06649F',
  colorBorderTranslateDefault: '#B57500',
  colorBorderOnghostDefault: '#ffffff',
  colorBorderOnghostHover: '#ffffff',
  colorBorderOnghostPressed: '#ffffff',
  colorBorderOnghostDisabled: '#adafb4',
  colorBorderPrivateDefault: '#444336',
  colorBorderStrongDefault: '#5A595F',
  colorBorderStrongDisabled: '#5A595F',
  colorBorderLowDefault: '#36353b',
  colorBorderLowHover: '#313235',
  colorBorderTeamDefault: '#6473C6',
  colorBorderVersatileSecondaryDefault: '#5a5f72',
  colorGradientPrimary: 'linear-gradient(270deg, #077DC7 0%, #143DA0 100%)',
  colorGradientLaunch: 'linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)',
  colorGradientScale: 'linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)',
  colorGradientLead: 'linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)',
  colorGradientPurple: 'linear-gradient(-90deg, #C177D5 30%, #653EAC 70%)',
  colorGradientOrange: 'linear-gradient(90deg, #C45A03 27.46%, #EEAF0C 100%)',
  colorGradientRed: 'linear-gradient(90deg, #F9062B 27.46%, #FFDBD4 100%)',
  colorGradientLightBlue: 'linear-gradient(45deg, #0789D9 0%, #62C2F9 100%)',
  colorGradientVideo:
    'linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)',
  colorGradientVideoOverlay:
    'linear-gradient(45deg, rgba(#174298, 0.7) 0%, rgba(#7148bd, 0.7) 52%, rgba(#af7ee6, 0.7) 100%)',
  colorGradientFindTimeNeutral:
    'repeating-linear-gradient(135deg, #303236, #303236 6px, #484A51 6px, #484A51 12px)',
  colorGradientFindTimePrimary:
    'repeating-linear-gradient(135deg, #012F49, #012F49 6px, #06456C 6px, #06456C 12px)',
  colorGradientFindTimeViolet:
    'repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)',
  colorGradientTruncate: '#e8198a00',
  colorGradientShimmer:
    'linear-gradient(-60deg, #e8198a 30%, #e8198a5, #e8198a 70%) right/300% 100%',
  colorGradientRainbow:
    'linear-gradient(90deg, rgb(90, 55, 154) 0%, rgb(184, 99, 207) 7%, rgb(20, 121, 179) 14%, rgb(73, 184, 248) 21%, rgb(85, 199, 82) 27%, rgb(39, 150, 118) 33.33%, rgb(104, 205, 101) 36%, rgb(98, 194, 249) 42%, rgb(22, 136, 202) 47%, rgb(193, 119, 213) 53%, rgb(101, 62, 172) 60%, rgb(22, 136, 202) 66.66%, rgb(98, 194, 249) 100%)',
  colorGradientNeutralToTransparent:
    'linear-gradient(to bottom, rgba(29, 30, 32, 1) 0%, rgba(29, 30, 32, 0) 100%)',
  colorTooltipFeature: '#0C285E',
  colorAvatarSteelLighter: '#36373a',
  colorAvatarSteelLight: '#313235',
  colorAvatarSteelDark: '#61636b',
  colorAvatarGrayLight: '#3e3d42',
  colorAvatarGrayDark: '#838288',
  colorAvatarGreen: '#239E7D',
  colorAvatarBlueLight: '#0789D9',
  colorAvatarBlueDark: '#3597d4',
  colorAvatarBlueDarker: '#7ABDE7',
  colorAvatarPink: '#9A4CB6',
  colorAvatarPurple: '#8D6BCC',
  colorAvatarYellow: '#B57500',
  colorAvatarOrange: '#EA6A00',
  colorAvatarSkeleton: '#2E2F33',
  colorChartPrimaryDefault: '#0789D9',
  colorChartBlueDefault: '#8DCDF2',
  colorChartTurquoiseDefault: '#34A6B2',
  colorChartPurpleDefault: '#653EAC',
  colorChartPurpleSubduedDefault: '#9554DE',
  colorChartGrayDefault: '#678198',
  colorChartGreenDefault: '#68CD65',
  colorChartGreenSubduedDefault: '#92E78D',
  colorChartGraySubduedDefault: '#859AAD',
  colorChartYellowDefault: '#DAA10B',
  colorChartYellowSubduedDefault: '#DCC105',
  colorChartGrayStrongDefault: '#425261',
  colorSeparatorTransparent: 'rgba(0,0,0,0.2)',
  colorLogoTypography: '#ffffff',
  colorCandidatesBgPrimaryDefault: '#0789D9',
  colorCandidatesBgGreenStrongDefault: '#1a8e68',
  colorCandidatesBgOrangeDefault: '#c45a03',
  colorCandidatesBgYellowDefault: '#f2b10d',
  colorCandidatesBgGreenSubduedDefault: '#2caa86',
  colorCandidatesBgBlueDefault: '#0C6090',
  colorCandidatesBgVioletDefault: '#512FA2',
  colorCandidatesBgGreenDefault: '#46af0e',
  colorCandidatesBgBlueStrongDefault: '#083F5E',
  colorCandidatesBgPurpleDefault: '#8c44a7',
  colorCandidatesBorderPrimaryDefault: '#1999E3',
  colorCandidatesBorderGreenStrongDefault: '#1a8e68',
  colorCandidatesBorderOrangeDefault: '#c45a03',
  colorCandidatesBorderYellowDefault: '#f2b10d',
  colorCandidatesBorderGreenSubduedDefault: '#2caa86',
  colorCandidatesBorderBlueDefault: '#0C6090',
  colorCandidatesBorderVioletDefault: '#512FA2',
  colorCandidatesBorderGreenDefault: '#46af0e',
  colorCandidatesBorderBlueStrongDefault: '#083F5E',
  colorCandidatesBorderPurpleDefault: '#8c44a7',
  avatarSteelLighter: '#36373a',
  avatarSteelLight: '#313235',
  avatarSteelDark: '#61636b',
  avatarGrayLight: '#3e3d42',
  avatarGrayDark: '#838288',
  avatarGreen: '#239E7D',
  avatarBlueLight: '#0789D9',
  avatarBlueDark: '#3597d4',
  avatarBlueDarker: '#7ABDE7',
  avatarPink: '#9A4CB6',
  avatarPurple: '#8D6BCC',
  avatarYellow: '#B57500',
  avatarOrange: '#EA6A00',
  avatarSkeleton: '#2E2F33',
  chartBrandDefault: '#0789D9',
  chartSkyDefault: '#8DCDF2',
  chartOceanDefault: '#34A6B2',
  chartOrchidDefault: '#653EAC',
  chartLavenderDefault: '#9554DE',
  chartSteelDefault: '#678198',
  chartEmeraldDefault: '#68CD65',
  chartMintDefault: '#92E78D',
  chartSmokeDefault: '#859AAD',
  chartSunflowerDefault: '#DAA10B',
  chartLemonDefault: '#DCC105',
  chartGraphiteDefault: '#425261',
  candidatesBgBrandDefault: '#0789D9',
  candidatesBgRainforestDefault: '#1a8e68',
  candidatesBgFireDefault: '#c45a03',
  candidatesBgGoldDefault: '#f2b10d',
  candidatesBgJungleDefault: '#2caa86',
  candidatesBgNavyDefault: '#0C6090',
  candidatesBgEggplantDefault: '#512FA2',
  candidatesBgGrassDefault: '#46af0e',
  candidatesBgDenimDefault: '#083F5E',
  candidatesBgLilacDefault: '#8c44a7',
  candidatesBorderBrandDefault: '#1999E3',
  candidatesBorderRainforestDefault: '#1a8e68',
  candidatesBorderFireDefault: '#c45a03',
  candidatesBorderGoldDefault: '#f2b10d',
  candidatesBorderJungleDefault: '#2caa86',
  candidatesBorderNavyDefault: '#0C6090',
  candidatesBorderEggplantDefault: '#512FA2',
  candidatesBorderGrassDefault: '#46af0e',
  candidatesBorderDenimDefault: '#083F5E',
  candidatesBorderLilacDefault: '#8c44a7',
};
